import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ApiMessageState {
  messages: string[];
}

const initialState: ApiMessageState = {
  messages: [],
};

const apiMessageSlice = createSlice({
  name: "apiMessages",
  initialState,
  reducers: {
    addApiMessage: (state, action: PayloadAction<string>) => {
      state.messages.push(action.payload);
    },
    clearApiMessages: (state) => {
      state.messages = [];
    },
  },
});

export const { addApiMessage, clearApiMessages } = apiMessageSlice.actions;
export default apiMessageSlice.reducer;
